import purpleLogoFM from 'static/images/app/fm/logo/light/logo.svg';
import purpleLogoFMShort from 'static/images/app/fm/logo/light/logoShort.svg';
import backgroundFM from 'static/images/old/signUpBackground.png';

import { THEME_NAME } from 'constants/theme';
import { HUB_INFO } from 'constants/hubs';

const PRODUCTION_CONFIG = {
  CURRENT_HUB_LABEL: 'Fusion Markets',
  CURRENT_HUB_THEME: 'FUSION_MARKETS',
  CURRENT_SHORT_HUB_LABEL: 'Fusion',
  API_HOST: 'https://api.fusionmarkets.com',
  HUB_PREFIX: '',
  LOGO: {
    [THEME_NAME.LIGHT]: {
      origin: purpleLogoFM,
      short: purpleLogoFMShort,
    },
  },
  LOGIN_BACKGROUND: backgroundFM,
  MIGRATION_HUBS: [HUB_INFO.FUSION_MARKETS, HUB_INFO.FUSION_MARKETS_X],
  CURRENCY_CLOUD_BANK_ROUTING_CODE: {
    ach_routing_number: {
      name: 'ACH Payment',
      description: 'Accepts payments originating in the US up to $1.000.000 sent via ACH.',
    },
    bic_swift: {
      name: 'SWIFT Payment',
      description: 'Used for international wire payments or high-value transactions.',
    },
    wire_routing_number: {
      name: 'Fedwire Payment',
      description: 'Accepts payments originating in the US up to $1.000.000 sent via Fedwire.',
    },
    sort_code: {
      name: 'UK Faster Payment',
      description:
        'Accepts payments up to £1,000,000 originating in the UK. Funds typically arrive within a few minutes of being sent, 24/7.',
    },
    routing_code: {
      name: 'EFT Payment',
      description: 'For local Canadian payments on the EFT payment schema',
    },
    eur_priority_regular: {
      name: 'SEPA Payment',
      description:
        'For euro payments to anywhere in the European Union. as well as number of non-EU countries, similar to a domestic payment.',
    },
  },
  FRESH_CHAT: {
    LICENSE: '7eb6d36b-9a3a-4468-9400-751f2cc30a3f',
    SCRIPT_URL: 'https://fusionmarkets.freshchat.com/js/widget.js',
    HOST: 'https://fusionmarkets.freshchat.com',
    LOCALE: 'en',
    TAGS: ['public', 'fusion'],
    APP_NAME: 'Fusion Markets',
    ALLOWED: true,
  },
  HUBS: [
    {
      ...HUB_INFO.FUSION_MARKETS,
      AVAILABLE_LANGUAGES: ['en'],
      ROUTING_HUB: '/au',
      MARKETING_SITE_URI: 'https://fusionmarkets.com.au',
      MARKETING_SITE: {
        MT4_WEB_TRADER_URL: '/Webtrader',
        MT5_WEB_TRADER_URL: '/MT5Webtrader',
        REGULATIONS_URL: '/About-us/Regulations',
        TV_BLOG_POST_URL: '/posts/tradingview-subscription',
      },
      AUTH_DISCLAIMER_I18_KEY: 'disclaimer',
    },
    {
      ...HUB_INFO.FUSION_MARKETS_X,
      AVAILABLE_LANGUAGES: ['en', 'th', 'chm', 'id', 'vn', 'es'],
      ROUTING_HUB: '/en',
      MARKETING_SITE_URI: 'https://fusionmarkets.com',
      MARKETING_SITE: {
        MT4_WEB_TRADER_URL: '/Webtrader',
        MT5_WEB_TRADER_URL: '/MT5Webtrader',
        REGULATIONS_URL: '/About-us/Regulations',
        TV_BLOG_POST_URL: '/posts/tradingview-subscription',
      },
      AUTH_DISCLAIMER_I18_KEY: 'disclaimerX',
    },
    {
      ...HUB_INFO.FUSION_MARKETS_EU,
      AVAILABLE_LANGUAGES: ['en'],
      ROUTING_HUB: '/eu',
      MARKETING_SITE_URI: 'https://fusionmarkets.com/eu',
      MARKETING_SITE: {
        MT5_WEB_TRADER_URL: '/MT5Webtrader',
        REGULATIONS_URL: '/About-us/Regulations',
        TV_BLOG_POST_URL: '/posts/tradingview-subscription',
      },
      AUTH_DISCLAIMER_I18_KEY: 'disclaimerCySec',
    },
  ],
  GOOGLE_TAG_MANAGER: {
    ID: 'GTM-PZG4W4R',
    THAI_ID: 'GTM-5XZ3FS8',
  },
  ACCOUNT_TYPES: [
    {
      i18nValue: 'common:constants.accountTypes.ZERO',
      value: 'ZERO',
    },
    {
      i18nValue: 'common:constants.accountTypes.classic',
      value: 'Classic',
    },
    {
      i18nValue: 'common:constants.accountTypes.swapFree',
      value: 'SWAP_FREE',
    },
  ],
  DEFAULT_DEPOSIT_METHOD: 'Praxis',
  MIGRATE_ACCOUNT_COUNTRIES: [
    'Singapore',
    'Malaysia',
    'United Kingdom of Great Britain and Northern Ireland',
    'Italy',
    'Germany',
    'South Africa',
    'Kenya',
    'Nigeria',
    'Australia',
  ],
  MIGRATE_ACCOUNT_COUNTRIES_HIDE: ['Australia'],
  HUB_NEED_MIGRATION_REQUEST: 'FUSION_MARKETS_X',
  UPGRADE_TO_PRO_COUNTRIES: ['Australia'],
  CAPTCHA: {
    client: '6Lfvb1IaAAAAAITnV_0lXae8oDeeFmsoThV-Z3xq',
    clientV3: '6LdoY-opAAAAANCu5Uy_cYGmSdYLpGYo8bIlhA0G',
  },
  PLACES: {
    API_KEY: 'AIzaSyAe7L5EMikm1_tqqto2pWGMXC2TibCk7xk',
  },
  GOOGLE_OAUTH: {
    CLIENT_ID: '271439598679-j1t2uph1u8mspccbm643e67061gk8p3j.apps.googleusercontent.com',
  },
  APPLE_SIGNIN: {
    CLIENT_ID: 'com.fusionmarkets.apple-sign-in-service',
    REDIRECT_URI: '/auth/sign-up',
  },
  FM_PLUS: new Set(['horner_sarah@hotmail.com', 'philhorner88@gmail.com', 'my3v11@yandex.ru']),
  ZEPTO: {
    TEST: false,
    ALLOW_ZEPTO: ['philhorner88@gmail.com', 'horner_sarah@hotmail.com', 'altst001@yandex.ru'],
  },
  FINMO: {
    TEST: false,
    ALLOW_FINMO: ['alexandershavelcoherent@gmail.com', 'kurian.amaljose@gmail.com'],
  },
  MONOOVA: {
    TEST: false,
    ALLOW_MONOOVA: ['alexandershavelcoherent@gmail.com', 'kurian.amaljose@gmail.com'],
  },
  TWILIO: {
    ALLOW_IM: [
      'adminx@fusionmarkets.com',
      'admin@fusionmarkets.com',
      'phil.horner@fusionmarkets.com',
      'david.swinden@fusionmarkets.com',
      'alexandergoncharov@coherentsolutions.com',
    ],
  },
  MT4_LIVE2_ALLOWED_USERS: new Set([
    'chris.hewitt@fusionmarkets.com',
    'swinden.d@gmail.com',
    'philhorner88@gmail.com',
    'alexandergoncharov@coherentsolutions.com',
  ]),
  HOTJAR: {
    ENABLED: true,
    ID: 3369381,
    SV: 6,
  },
  FINGERPRINT: {
    ENABLED: false, // Disable for now as it doesn't work anyway.
    API_KEY: 'ROjggEi34zGysBChqZLl',
  },
  FIREBASE: {
    apiKey: 'AIzaSyC7T9NimVOkhTwMgfP-kUjVnuw98Y7OVUo',
    authDomain: 'fusionmarkets.firebaseapp.com',
    projectId: 'fusionmarkets',
    storageBucket: 'fusionmarkets.appspot.com',
    messagingSenderId: '271439598679',
    appId: '1:271439598679:web:d7204f6d171cde9250bf12',
    measurementId: 'G-2Z3MPLQ7VM',
  },
  TINY_API_KEY: 'gto7lwowtye3zi8bqa7e3c77vw03x9g778ml0ggxt170mdci',
  MAILCHIMP: {
    SUBSCRIPTION_URL:
      'https://fusionmarkets.us20.list-manage.com/subscribe?u=5e19c3262725b9c48b50569e0&id=07665efbe3',
  },
  SALES_TEAM_USERS: new Set([
    'graham.miller@fusionmarkets.com',
    'edward.ali@fusionmarkets.com',
    'mitchell.sinnatamby@fusionmarkets.com',
    'xavier.herrera@fusionmarkets.com',
    'tom.laragy@fusionmarkets.com',
    'juan.cortez@fusionmarkets.com',
    'arno.venter@fusionmarkets.com',
  ]),
  SALES_REPORTS_USERS: new Set([
    'graham.miller@fusionmarkets.com',
    'edward.ali@fusionmarkets.com',
    'mitchell.sinnatamby@fusionmarkets.com',
    'xavier.herrera@fusionmarkets.com',
    'tom.laragy@fusionmarkets.com',
    'arno.venter@fusionmarkets.com',
    'amal.jose@fusionmarkets.com',
    'torrell.fernandes@fusionmarkets.com',
  ]),
  DAY1_SIGN_URL: 'https://exchange.day1x.io',
  TV_SUBSCRIPTION_PLANS_URL: 'https://www.tradingview.com/pricing/',
  HELP_EMAIL: 'help@fusionmarkets.com',
  BRAZE: {
    API_KEY: '8b7f4e3c-0de0-4ddf-9426-d2a8ffc24068',
    API_URL: 'https://sdk.iad-07.braze.com',
  },
  HELP_TEAM_EMAIL: 'help@fusionmarkets.com',
};

export default PRODUCTION_CONFIG;
